/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsExclamation: {
  name: 'exclamation';
  data: string;
} = {
  name: 'exclamation',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 7a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V7Zm-1 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
